import { User } from "@supabase/supabase-js";

export const getUserMobileNumber = (
  user: User | null | undefined,
): string | null => {
  if (!user?.phone) {
    return null;
  }

  return user.phone.replace(/^63/, "");
};
